<template>
    <div>
        <slot
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
        ></slot>
        <footer class="modal-footer">
            <button @click="close()" class="btn btn-secondary" type="button">
                Cancel
            </button>
            <button @click="save()" class="btn btn-primary" type="button">
                Create
            </button>
        </footer>
    </div>
</template>

<script>
import AddNewMixin from "../AddNewMixin";

export default {
    name: "OCrudDialog",
    mixins: [AddNewMixin],
    props: {
        title: { type: String, default: "" },
        value: { type: Boolean, default: false },
    },
    data() {
        return {
            item: {},

            serverErrors: {},

            clean: true, // add here so we can watch it

            formState: {
                dirty: false,
                invalid: false,
                error: false,
                init: true,
                debug: false,
                //Remove
                valid: true,
            },
        };
    },
    methods: {
        createItem() {
            if (typeof this.the_store.createNew !== "undefined") {
                this.the_store.createNew().then((data) => {
                    this.item = data;
                });
            } else {
                this.item = {};
            }
        },
        save() {
            var vm = this;
            vm.create_new_item(this.item, function (response) {
                vm.$emit("change", response.id);
            });
        },
        close() {
            this.$emit("close", null);
        },
    },
    created() {
        this.createItem();
    },
};
</script>

<style scoped></style>
